module.exports = __webpack_public_path__ + "img/icon_star_rate_inactive.b1f4c883.svg";